import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { getDiscountCoupon } from '@/services/discountCoupon.service';
import { AppliedCouponResponseDTO } from '@/DTO/checkoutResponseDTO';
import { useUserProfile } from './useUserData';
import { AccessProfile } from '@/helpers/accessProfileUtil';

export const useGetDiscountCoupon = () => {
    const userProfile = useUserProfile();

    return useMutation({
        mutationFn: async (code: string) => {
            // Bloquear owners de aplicarem cupom
            const user = userProfile.data;
            const isOwner = user && (
                user.accessProfile?.enumKey === AccessProfile.Owner ||
                user.accessProfile?.enumKey === AccessProfile.TAC_OWNER ||
                user.accessProfile?.enumKey === AccessProfile.Dependent ||
                user.accessProfile?.enumKey === AccessProfile.TAC_DEPENDENT
            );
            if (isOwner) {
                throw new Error('Esse cupom não está disponível para seu perfil de acesso');
            }

            const { coupon, error } = await getDiscountCoupon(code);
            if (error) {
                throw new Error(error);
            }
            return coupon as AppliedCouponResponseDTO;
        },
        onError: (error: Error) => {
            toast.error(error.message || 'Cupom inválido ou não encontrado');
        },
    });
};
